// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import store from '@/store/index.js'
import breadcrumb from "@/components/breadcrumb.vue"
import breadcrumbs from "@/components/breadcrumbs.vue"
Vue.prototype.$url = "https://test.metabiz.com.cn/api/public/";

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.component("breadcrumb",breadcrumb);//面包屑导航
Vue.component("breadcrumbs",breadcrumbs);//面包屑导航

import ElementUI from 'element-ui'
//element-ui引入
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.component("mavonEditor",mavonEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js